import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, ChevronDown } from 'lucide-react';
const testimonials = [{
  name: 'Carlos Rodríguez',
  role: 'Alumno - Buenos Aires',
  text: 'Excelente material. No sabía nada de cerrajería y ahora ya estoy haciendo mis primeros trabajos a domicilio. Muy claro todo.',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  name: 'María Elena Costa',
  role: 'Alumna - Córdoba',
  text: 'Me sirvió muchísimo para ahorrar en casa. Ya arreglé tres cerraduras que estaban trabadas. El manual de bonus es genial.',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  name: 'Juan Pablo Martínez',
  role: 'Alumno - Rosario',
  text: 'La biblia del lockpicking es otro nivel. Muy detallado y con fotos que ayudan un montón a entender el mecanismo interno.',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  name: 'Roberto Sánchez',
  role: 'Alumno - Mendoza',
  text: 'Lo compré por curiosidad y terminó siendo mi nueva salida laboral. El pack premium vale cada centavo por los cursos extra.',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  name: 'Laura Gómez',
  role: 'Alumna - Salta',
  text: 'Muy bien organizado. Me gusta que podés estudiar a tu ritmo. El acceso fue inmediato como prometieron.',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=200',
  rating: 4
}, {
  name: 'Diego Fernández',
  role: 'Alumno - Neuquén',
  text: 'Increíble la cantidad de información. El curso de automotriz me abrió puertas que no esperaba. Muy recomendable.',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  name: 'Patricia Sosa',
  role: 'Alumna - Tucumán',
  text: 'Soy jubilada y buscaba algo para entretenerme y ganar unos pesos. Aprendí rápido y ya le arreglé la puerta a varios vecinos.',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  name: 'Andrés Villa',
  role: 'Alumno - Entre Ríos',
  text: 'El soporte es muy bueno y el material es de calidad profesional. Las técnicas de apertura son muy efectivas.',
  image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  name: 'Sofía Castro',
  role: 'Alumna - San Juan',
  text: 'Lo mejor es que es digital y lo tengo siempre en el celu. Si me olvido de algo, lo consulto en el momento.',
  image: 'https://images.unsplash.com/photo-1554151228-14d9def656e4?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  name: 'Miguel Ángel Ruiz',
  role: 'Alumno - Misiones',
  text: 'Excelente inversión. Ya recuperé lo que pagué con el primer trabajo que hice. Muy agradecido por la oportunidad.',
  image: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  name: 'Lucía Méndez',
  role: 'Alumna - Chaco',
  text: 'Las explicaciones son paso a paso. No te perdés nunca. Los videos complementan perfecto la lectura.',
  image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&q=80&w=200',
  rating: 4
}, {
  name: 'Fernando Silva',
  role: 'Alumno - Santa Fe',
  text: 'Un oficio que nunca muere. Con este curso tenés la base sólida para ser un profesional. Muy completo.',
  image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  name: 'Gabriela Torres',
  role: 'Alumna - La Pampa',
  text: 'Me encantó el enfoque práctico. Nada de vueltas innecesarias. Vas directo a lo que importa.',
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  name: 'Jorge Herrera',
  role: 'Alumno - Chubut',
  text: 'Muy buen material para los que queremos empezar de cero. El precio es muy accesible para todo lo que trae.',
  image: 'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?auto=format&fit=crop&q=80&w=200',
  rating: 5
}, {
  name: 'Elena Vázquez',
  role: 'Alumna - San Luis',
  text: 'La mejor decisión que tomé este año. Ya tengo mi propio kit de herramientas y estoy trabajando a full.',
  image: 'https://images.unsplash.com/photo-1544717297-fa154da09f5b?auto=format&fit=crop&q=80&w=200',
  rating: 5
}];
export function Testimonials() {
  const [showAll, setShowAll] = useState(false);
  const visibleTestimonials = showAll ? testimonials : testimonials.slice(0, 5);
  return <section className="py-20 bg-white px-4" data-id="element-157">
      <div className="max-w-5xl mx-auto" data-id="element-158">
        <h2 className="text-3xl md:text-4xl font-bold text-[#5d4037] text-center mb-12" data-id="element-159">
          Lo que dicen nuestros alumnos
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-160">
          <AnimatePresence mode="popLayout" data-id="element-161">
            {visibleTestimonials.map((t, i) => <motion.div key={t.name} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            scale: 0.95
          }} transition={{
            delay: i * 0.05
          }} className="bg-[#fdfaf6] p-6 rounded-[2rem] border border-[#eaddca] shadow-sm flex flex-col h-full" data-id="element-162">
                <div className="flex items-center gap-4 mb-4" data-id="element-163">
                  <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full object-cover border-2 border-[#d4af37]" data-id="element-164" />
                  <div data-id="element-165">
                    <h3 className="font-bold text-[#5d4037] text-sm" data-id="element-166">
                      {t.name}
                    </h3>
                    <p className="text-[#8b6b61] text-[10px]" data-id="element-167">{t.role}</p>
                  </div>
                </div>
                <div className="flex gap-1 mb-3" data-id="element-168">
                  {[...Array(t.rating)].map((_, i) => <Star key={i} className="w-3 h-3 fill-[#d4af37] text-[#d4af37]" data-id="element-169" />)}
                </div>
                <p className="text-[#5d4037] text-xs leading-relaxed italic flex-grow" data-id="element-170">
                  "{t.text}"
                </p>
              </motion.div>)}
          </AnimatePresence>
        </div>

        {!showAll && <div className="mt-12 text-center" data-id="element-171">
            <button onClick={() => setShowAll(true)} className="inline-flex items-center gap-2 bg-[#d4af37] hover:bg-[#c4a030] text-white font-bold py-4 px-10 rounded-full shadow-lg transition-all transform hover:scale-105 active:scale-95" data-id="element-172">
              VER MÁS COMENTARIOS
              <ChevronDown className="w-5 h-5" data-id="element-173" />
            </button>
          </div>}
      </div>
    </section>;
}